import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type StatusPillCategory = 'complete' | 'in-progress' | 'updated';

const STATUS_PILL_LABELS: Record<StatusPillCategory, string> = {
  complete: 'Complete',
  'in-progress': 'In Progress',
  updated: 'Updated',
};

@Component({
  selector: 'ui-status-pill',
  templateUrl: './status-pill.component.html',
  styleUrls: ['./status-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusPillComponent {
  @Input() category!: StatusPillCategory;

  get label(): string {
    return STATUS_PILL_LABELS[this.category];
  }
}
